import {Attendance, Employee, EmployeePostEdit, Office, OfficePostEdit, WorkTime, WorkTimePostEdit,} from './index'
import {AiOutlineClockCircle, AiOutlineHome, AiOutlineTeam} from "react-icons/ai";
import {MdOutlineWorkHistory} from "react-icons/md";


export const authRole = {
    admin: 'admin',
}


export const samplePagesConfigs = [
    // {
    //     key: 1,
    //     icon: <RxDashboard className={'icon'} style={{fontSize: 24, height: '100%'}}/>,
    //     path: '/dashboard',
    //     label: 'Панель',
    //     element: Dashboard,
    //     permittedRole: [authRole.admin ],
    //     isBackground: false
    // },
    {
        key: 11,
        label: 'Посещаемость',
        icon: <MdOutlineWorkHistory className='icon' style={{fontSize: 24}}/>,
        path: '/attendance',
        element: Attendance,
        permittedRole: [authRole.admin],
        isBackground: true
    },
    {
        key: 8,
        label: 'Офис',
        icon: <AiOutlineHome className='icon' style={{fontSize: 24}}/>,
        path: '/office',
        element: Office,
        permittedRole: [authRole.admin],
        isBackground: true
    },
    {
        path: '/office/add',
        element: OfficePostEdit,
        permittedRole: [authRole.admin],
        isBackground: true,
        noIndex: true
    },
    {
        key: 9,
        label: 'Рабочее время',
        icon: <AiOutlineClockCircle className='icon' style={{fontSize: 24}}/>,
        path: '/work-time',
        element: WorkTime,
        permittedRole: [authRole.admin],
        isBackground: true
    },
    {
        path: '/work-time/add',
        element: WorkTimePostEdit,
        permittedRole: [authRole.admin],
        isBackground: true,
        noIndex: true
    },
    {
        key: 10,
        label: 'Сотрудники',
        icon: <AiOutlineTeam className='icon' style={{fontSize: 24}}/>,
        path: '/employee',
        element: Employee,
        permittedRole: [authRole.admin],
        isBackground: true
    },
    {
        path: '/employee/add',
        element: EmployeePostEdit,
        permittedRole: [authRole.admin],
        isBackground: true,
        noIndex: true
    },


];